import { gql } from '@apollo/client';
import { commentFields } from '../queries/commentFields';

export const addLikeMutation = gql`
  ${commentFields}
  mutation addLike($commentId: ID!, $userId: ID!) {
    updateComment(where: { id: $commentId }, data: { likes: { connect: { id: $userId } } }) {
      ...CommentFields
    }
  }
`;

export const removeLikeMutation = gql`
  ${commentFields}
  mutation removeLike($commentId: ID!, $userId: ID!) {
    updateComment(where: { id: $commentId }, data: { likes: { disconnect: { id: $userId } } }) {
      ...CommentFields
    }
  }
`;
